import { useState } from "react";

export function useDeleteModal(
  deleteFn: (id: number, messageStore: any) => Promise<boolean>,
  messageStore: any,
  onDeleted: (id: number) => void,
) {
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<{
    id: number;
    title: string;
  } | null>(null);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleDeleteClick = (id: number, title: string): void => {
    setItemToDelete({ id, title });
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async (): Promise<void> => {
    if (!itemToDelete) return;
    setIsDeleting(true);
    const success = await deleteFn(itemToDelete.id, messageStore);
    setIsDeleting(false);
    if (success) onDeleted(itemToDelete.id);
    setDeleteModalOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteModalClose = (): void => {
    setDeleteModalOpen(false);
    setItemToDelete(null);
  };

  return {
    deleteModalOpen,
    itemToDelete,
    isDeleting,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDeleteModalClose,
  };
}
